function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAddUsersSvg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 885.01 898.24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "m401.33,409.42c-118.4,0-214.38,63.69-214.38,142.26v42.42c0,17.35,14.17,32.41,34.31,36.66,120.05,25.31,240.09,25.31,360.14,0,20.14-4.25,34.31-19.31,34.31-36.66v-42.42c0-78.57-95.98-142.26-214.38-142.26Z",
    style: {
      fill: "#3d5ba9"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 401.33,
    cy: 269.76,
    r: 170.87,
    style: {
      fill: "#eaecee"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 401.33,
    cy: 269.76,
    r: 130.67,
    style: {
      fill: "#3d5ba9"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 401.33,
    cy: 401.33,
    r: 381.38,
    style: {
      fill: "none",
      stroke: "#3d5ba9",
      strokeMiterlimit: 10,
      strokeWidth: "39.89px"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 664.32,
    cy: 677.54,
    r: 220.7,
    transform: "translate(-284.52 668.19) rotate(-45)",
    style: {
      fill: "#eaecee"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 664.32,
    cy: 677.54,
    r: 186.77,
    transform: "translate(-284.52 668.19) rotate(-45)",
    style: {
      fill: "#3d5ba9"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 554.27,
    y1: 677.54,
    x2: 774.37,
    y2: 677.54,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinejoin: "round",
      strokeWidth: "56.62px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 664.32,
    y1: 787.59,
    x2: 664.32,
    y2: 567.49,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinejoin: "round",
      strokeWidth: "56.62px"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddUsersSvg);
export default __webpack_public_path__ + "static/media/addUsersSvg.7b202574c800c408805d45f7830e4590.svg";
export { ForwardRef as ReactComponent };